<template>
  <div class="sysmenu-index">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'SysmenuIndex',
  props: {},
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>

<style lang="scss" scoped>
.sysmenu-index {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/sysmenu/index.vue